module.exports = __webpack_public_path__ + "static/img/IMG_0898.b3eddf8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/IMG_0898.jpeg
// module id = 4WZF
// module chunks = 0